export interface Defect {
  id: number;
  defectNumber: string;
  vehicle: {
    id: number;
    make: string;
    model: string;
    year: number;
    licensePlate?: string;
  };
  company: {
    id: number;
    companyName: string;
  };
  type: DefectType;
  severity: DefectSeverity;
  status: DefectStatus;
  title: string;
  description: string;
  location?: string; // Front, Rear, Left, Right, Interior, etc.
  component?: string; // Engine, Brakes, Tires, etc.
  reportedByUser?: {
    id: number;
    firstName: string;
    lastName: string;
  };
  reportedByEmployee?: {
    id: number;
    firstName: string;
    lastName: string;
  };
  reportedDate: string;
  reportedDuringReservationId?: number;
  assignedToEmployee?: {
    id: number;
    firstName: string;
    lastName: string;
  };
  investigationNotes?: string;
  rootCause?: string;
  resolutionNotes?: string;
  investigationStartDate?: string;
  investigationCompletedDate?: string;
  resolutionDate?: string;
  estimatedResolutionDate?: string;
  safetyImpact: boolean;
  operationalImpact: boolean;
  customerImpact: boolean;
  vehicleOutOfService: boolean;
  estimatedDowntimeDays?: number;
  actualDowntimeDays?: number;
  photoUrls?: string;
  documentUrls?: string;
  followUpRequired: boolean;
  followUpDate?: string;
  followUpNotes?: string;
  createdAt: string;
  updatedAt: string;
}

export enum DefectType {
  MECHANICAL = 'MECHANICAL',
  ELECTRICAL = 'ELECTRICAL',
  BODY_DAMAGE = 'BODY_DAMAGE',
  INTERIOR_DAMAGE = 'INTERIOR_DAMAGE',
  TIRE_ISSUE = 'TIRE_ISSUE',
  BRAKE_ISSUE = 'BRAKE_ISSUE',
  ENGINE_ISSUE = 'ENGINE_ISSUE',
  TRANSMISSION_ISSUE = 'TRANSMISSION_ISSUE',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  SAFETY_EQUIPMENT = 'SAFETY_EQUIPMENT',
  CLEANLINESS = 'CLEANLINESS',
  FUEL_SYSTEM = 'FUEL_SYSTEM',
  EXHAUST_SYSTEM = 'EXHAUST_SYSTEM',
  SUSPENSION = 'SUSPENSION',
  OTHER = 'OTHER',
}

export enum DefectSeverity {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export enum DefectStatus {
  REPORTED = 'REPORTED',
  INVESTIGATING = 'INVESTIGATING',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
  DUPLICATE = 'DUPLICATE',
}

export interface DefectCreateRequest {
  vehicleId: number;
  companyId?: number;
  type: DefectType;
  severity: DefectSeverity;
  title: string;
  description: string;
  location?: string;
  component?: string;
  reportedDuringReservationId?: number;
  safetyImpact?: boolean;
  operationalImpact?: boolean;
  customerImpact?: boolean;
  vehicleOutOfService?: boolean;
  photoUrls?: string;
}

